import React, { useEffect, useState } from 'react'
import { deleteTalent, loadTalents, getCachedTalents } from '../utils/Network'
import { BuildTalents, getDefaultName, talentImageSrc } from '../utils';
import TalentCardsWidget from './talent/widgets/TalentCardsWidget';
import BreadCrumbs from '../components/shared/BreadCrumbs';

const DEFAULT_IMAGE = '/assets/images/default.png';

const getUserTalentsCount = (item) => {
    if (!item) return 0;
    const raw = item.count_of_usertalents ?? 0;
    const count = Number(raw);
    return Number.isFinite(count) ? count : 0;
};

const parentsFromTalents = (talents) => {
    if (!Array.isArray(talents)) return [];
    return BuildTalents(talents).filter((item) => parseInt(item.parent || 0, 10) === 0);
};

export default function TalentsContent() {
    const [loading, setLoading] = useState(0);
    const [show_delete, setShowDelete] = useState(false);
    const [Talents, setTalents] = useState(() => parentsFromTalents(getCachedTalents()));
    const [grid_view, setGridView] = useState(false);
    const [expandedItems, setExpandedItems] = useState({});

    const fetchTalents = (force = false) => {
        loadTalents(null, { force }).then((talents) => {
            setTalents(parentsFromTalents(talents));
        });
    };

    useEffect(() => {
        fetchTalents(true);
    }, []);

    const handleDelete = (talentId, e) => {
        e.preventDefault();
        setLoading(talentId);
        deleteTalent(talentId).then(() => {
            setLoading(0);
            fetchTalents(true);
        })
    }

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete)
    }

    const toggleView = (e) => {
        e.preventDefault();
        setGridView(!grid_view);
    }

    const toggleAccordionItem = (itemId, e) => {
        e.preventDefault();
        setExpandedItems((prev) => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    }

    const getTalentImage = (item) => talentImageSrc(item, DEFAULT_IMAGE);

    const renderTalentNode = (item, depth = 0) => {
        const hasChildren = item.childs && item.childs.length > 0;
        const isExpanded = !!expandedItems[item.id];

        const depthClass =
            depth >= 1 ? ' talent-hierarchy-item--third-level' : '';

        return (
            <li
                key={`talent-node-${item.id}`}
                className={`talent-hierarchy-item${depthClass}`}
                style={{ marginLeft: depth * 3, display: 'block' }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                    {loading === item.id ? (
                        <span className="talent-hierarchy-child-link">Loading...</span>
                    ) : (
                        <div>
                            <a className="talent-hierarchy-child-link" href={`/cms/talents/${item.id}`}>
                                {getDefaultName(item.names)}
                            </a>{' '}
                            <a
                                className="talent-count-inline talent-count-inline--link"
                                href={`/cms/talent/${item.id}`}
                                title="View participants"
                            >
                                ({getUserTalentsCount(item)})
                            </a>
                        </div>
                    )}
                    <div className="pull-right" style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                        {hasChildren && (
                            <button
                                type="button"
                                className="btn btn-cm btn-xs"
                                title={isExpanded ? 'Hide childs' : 'Show childs'}
                                onClick={(e) => toggleAccordionItem(item.id, e)}
                            >
                                <i className={`fa ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                            </button>
                        )}
                        {show_delete && (
                            <button
                                type="button"
                                className="btn btn-danger btn-xs"
                                onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }}
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                        )}
                    </div>
                </div>
                {hasChildren && isExpanded && (
                    <ul className="list-unstyled talent-hierarchy-list" style={{ width: '100%', marginTop: 8 }}>
                        {item.childs.map((child) => renderTalentNode(child, depth + 1))}
                    </ul>
                )}
            </li>
        );
    }

    return (
        <>
            <div className="content-wrapper cms-ratings-surface">
                <section className="content padding-top-sm-0">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box box-primary">
                                <div className="box-header with-border">
                                    <h3 className="box-title ">
                                        Talents{' '}
                                        <span style={{ fontSize: 11 }}>({Talents.length})</span>
                                    </h3>
                                    <a title="Add Category" className="btn btn-cm margin-r-5 pull-right mt-2p " href="/cms/talents/new"><i className="fa fa-plus"></i></a>
                                    <button type="button" title="Show Delete Button" className="btn btn-cm margin-r-5 pull-right mt-2p " onClick={showDelete}><i className="fa fa-trash"></i></button>
                                    <button type="button" title="Change View" className="btn btn-cm margin-r-5 pull-right mt-2p " onClick={toggleView}>
                                        <i className={`fa ${grid_view ? 'fa-list' : 'fa-th'}`}></i>
                                    </button>
                                </div>
                                <div className="box-body p-4">
                            {grid_view && (
                                <TalentCardsWidget
                                    talents={Talents}
                                    showDelete={show_delete}
                                    loading={loading}
                                    onDelete={handleDelete}
                                />
                            )}
                            {!grid_view && (
                                <div className="row talent-hierarchy-row">
                                    {Talents.map((item) => (
                                        <div key={item.id} className="talent-hierarchy-col">
                                            <div className="talent-hierarchy-card">
                                                <div className="talent-hierarchy-header">
                                                    <h4 className="talent-hierarchy-title">
                                                        <a className="talent-hierarchy-parent-link" href={`/cms/talents/${item.id}`}>
                                                            {getDefaultName(item.names)}
                                                        </a>{' '}
                                                        {item.parent && (
                                                        <a
                                                            className="talent-count-inline talent-count-inline--link"
                                                            href={`/cms/talent/${item.id}`}
                                                            title="View participants"
                                                        >
                                                            ({getUserTalentsCount(item)})
                                                        </a>
                                                        )}
                                                    </h4>
                                                    <div className="pull-right" style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                                        {item.childs && item.childs.length > 0 && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-cm btn-xs"
                                                                title={expandedItems[item.id] ? 'Hide childs' : 'Show childs'}
                                                                onClick={(e) => toggleAccordionItem(item.id, e)}
                                                            >
                                                                <i className={`fa ${expandedItems[item.id] ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="talent-hierarchy-body">
                                                    <div className="clearfix" style={{ marginBottom: '8px' }}>
                                                        {show_delete && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-xs pull-right"
                                                                onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }}
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                    {!expandedItems[item.id] && (
                                                        <div className="talent-hierarchy-body-collapsed">
                                                            <a
                                                                className="talent-hierarchy-thumb-wrap"
                                                                href={`/cms/talents/${item.id}`}
                                                                title={getDefaultName(item.names)}
                                                            >
                                                                <img
                                                                    className="talent-hierarchy-thumb"
                                                                    src={getTalentImage(item)}
                                                                    alt={getDefaultName(item.names)}
                                                                />
                                                            </a>
                                                            <a
                                                                className="talent-card-count talent-hierarchy-body-count"
                                                                href={`/cms/talent/${item.id}`}
                                                                title="View participants"
                                                            >
                                                                <i className="fa fa-users"></i>
                                                                {getUserTalentsCount(item)}
                                                            </a>
                                                        </div>
                                                    )}

                                                    {item.childs && item.childs.length > 0 && expandedItems[item.id] && (
                                                        <ul className="list-unstyled talent-hierarchy-list">
                                                            {item.childs.map((child) => renderTalentNode(child))}
                                                        </ul>
                                                    )}
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
